import { Steps } from "antd";
import { useTranslation } from "react-i18next";
import { stagesDataTransformer } from "containers/cardOnboarding/services/data.transformers";

const OnbSteps = ({ data, currentData, failed }) => {
  const { t } = useTranslation();

  return (
    <div className="px-10 text-center ">
      <span className="text-gray-4 body-16px-demibold">
        {t("card-page.stages-steps")}
      </span>
      <div className="flex gap-2 justify-center mt-2">
        <img
          className="max-h-[20px]"
          src={"https://cdn.firouzeh.com/public/bank-MiddleEast-logo-light.png"}
          alt="bank"
        />
        <span className="caption-12px-medium text-gray-0">
          با همکاری بانک خاورمیانه
        </span>
      </div>
      <Steps
        className="bank-steps mt-6"
        direction="vertical"
        size="small"
        status={failed && "error"}
        current={currentData}
        percent={100}
        items={stagesDataTransformer(data, currentData)}
        responsive={false}
      />
    </div>
  );
};
export default OnbSteps;
